import React, { Component } from 'react';
import './lop-du-lieu.scss';
import { connect } from 'react-redux';

import {
  getDataPhuong,
  getDataQuan,
} from '../../../../../redux/actions/search.action';
import { AxiosGetSecretApi } from '../../../../../utils/fetchApi';
import { Button } from 'antd';
import StaticClass from '../../../../../utils/staticClass';
import { LocalStore } from '../../../../../utils/LocalStore/index';
class SearchResultKienTruc extends Component {
  constructor(props) {
    super(props);

    this.state = {
      quan: '-',
    };

    this.listDuAnTitle = [
      'Mã khu vực',
      'Tên khu vực',
      'Chỉ giới xây dựng',
      'Tầng cao xây dựng',
      'Chiều cao mỗi tầng',
      'Cốt nền',
      'Mật độ xây dựng',
      'Quy định khác',
      'Phường/Xã',
      'Quận/Huyện',
      'Quyết định pháp lý',
    ];

    this.listDuAnValue = [
      'MaKV',
      'TenKhuVuc',
      'ChiGioiXD',
      'TangCaoXD',
      'ChieuCaoTang',
      'CotNen',
      'MatDoXD',
      'QDKhac',
      'Phuong',
      'Phuong',
    ];
  }

  componentDidMount() {
    if (this.props.listQuan.length === 0) this.props.getDataQuan();
    if (this.props.listPhuong.length === 0) this.props.getDataPhuong();
    this.getPhuong();
    this.onSearchByObjectId();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.data !== this.props.data) {
      this.getPhuong();
      this.onSearchByObjectId();
      this.props.hidePoint();
      this.setState({
        isShowLocation: false,
      });
    }
    if (prevProps.listQuan !== this.props.listQuan) {
      this.setState({ listQuan: this.props.listQuan });
      this.getPhuong();
    }

    if (prevProps.listPhuong !== this.props.listPhuong) {
      this.setState({ listPhuong: this.props.listPhuong });
      this.getPhuong();
    }
  }

  getPhuong = () => {
    this.props.listPhuong.forEach((e) => {
      if (this.props.data && this.props.data.MaXa === e.MaPhuong) {
        this.props.listQuan.forEach((o) => {
          if (o.MAHUYEN === e.MaQuan) {
            this.setState({
              quan: o.TENHUYEN,
            });
            return;
          }
        });
      }
    });
  };

  onSearchByObjectId = async () => {
    this.setState({
      isLoading: true,
    });
    if (this.props.data.OBJECTID) {
      let id = this.props.data.OBJECTID;
      // return
      let url = `/api/vung-kien-truc/search?curPage=1&pageSize=10&OBJECTID=${id}`;
      let res = await AxiosGetSecretApi(url);
      if (
        res &&
        res.dataResult &&
        res.dataResult.length > 0 &&
        res.dataResult[0].OBJECTID
      ) {
        this.getGeoData(res.dataResult[0].OBJECTID);
        this.setState({ data: res.dataResult[0] });
      }
    }
  };

  async getGeoData(id) {
    let res = await AxiosGetSecretApi(
      `https://gis-quyhoach.greenglobal.vn/server/rest/services/SoXayDung/QuyHoachDoThi/MapServer/3/query?f=json&where=1%3D1&returnGeometry=true&spatialRel=esriSpatialRelIntersects&objectIds=${id}&outFields=*&outSR=102100`
    );
    if (
      res &&
      res.features &&
      Array.isArray(res.features) &&
      res.features.length !== 0 &&
      res.features[0].geometry &&
      res.features[0].geometry.rings
    )
      this.props.drawRing(res.features[0].geometry.rings);
    // console.log(res.features[0].geometry.rings)
  }

  showLocation() {
    if (this.state.isShowLocation) {
      this.props.hidePoint(this.state.data);
    } else {
      this.props.showPoint(this.state.data);
      setTimeout(() => {
        document
          .getElementById('listlocation')
          .scrollIntoView({ behavior: 'smooth' });
      }, 50);
    }
    this.setState({
      isShowLocation: !this.state.isShowLocation,
    });
  }

  render() {
    return (
      <div className='search-result-lop-du-lieu'>
        <div className='search-500-header'>
          Thông tin kiến trúc xây dựng
          <i className='fas fa-times icon-close' onClick={this.props.close}></i>
        </div>

        <div className='search-500-body'>
          {this.listDuAnTitle.map((e, i) => (
            <div style={{ display: 'flex' }} key={i}>
              <div className='col-left-kien-truc search-500-text'>{e}:</div>

              <div className='col-right-kiet-truc search-500-text-gray'>
                {this.props.data[`${this.listDuAnValue[i]}`]
                  ? this.props.data[`${this.listDuAnValue[i]}`] !== 'Null' &&
                    this.props.data[`${this.listDuAnValue[i]}`] !== 'null'
                    ? i === 9
                      ? this.state.quan
                      : this.props.data[`${this.listDuAnValue[i]}`]
                    : '-'
                  : '-'}
              </div>
            </div>
          ))}

          {this.props.file && (
            <div style={{ display: 'flex' }}>
              <div className='col-left-kien-truc search-500-text'>
                File đính kèm:
              </div>
              <div>
                {this.props.file.map((e, i) => (
                  <div
                    className='col-right-kiet-truc search-500-text'
                    style={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      maxWidth: '125px',
                    }}
                  >
                    <a href={e.Duongdanfiledinhkem}>{e.Tenfiledinhkem}</a>
                  </div>
                ))}
              </div>
            </div>
          )}

          {localStorage.loginSession && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: '10px',
              }}
            >
              <Button
                type='primary'
                className='search-result-button'
                onClick={() => this.showLocation()}
              >
                {this.state.isShowLocation ? 'Ẩn toạ độ' : 'Hiện toạ độ'}
              </Button>
            </div>
          )}
          {this.state.isShowLocation ? (
            <div
              style={{
                textAlign: 'center',
                maxHeight: '300px',
                overflow: 'auto',
                marginBottom: '10px',
                marginTop: '10px',
                padding: '0 10px 10px 10px',
              }}
            >
              <table style={{ width: '100%' }}>
                <tbody>
                  <tr>
                    <th
                      style={{
                        border: '1px solid #a3a3a3',
                        width: '80px',
                      }}
                    >
                      Số hiệu góc thửa
                    </th>
                    <th style={{ border: '1px solid #a3a3a3' }}>X(m)</th>
                    <th style={{ border: '1px solid #a3a3a3' }}>Y(m)</th>
                  </tr>
                  {this.state.data &&
                    this.state.data.SHAPE &&
                    this.state.data.SHAPE.length === undefined &&
                    this.state.data.SHAPE.points.map((o, index, arr) => {
                      if (index < this.state.data.SHAPE.points.length - 1)
                        return (
                          <tr key={index}>
                            <td style={{ border: '1px solid #a3a3a3' }}>
                              {index + 1}
                            </td>
                            <td style={{ border: '1px solid #a3a3a3' }}>
                              {StaticClass.formatNumberFloat(o.x)}
                            </td>
                            <td style={{ border: '1px solid #a3a3a3' }}>
                              {StaticClass.formatNumberFloat(o.y)}
                            </td>
                          </tr>
                        );
                    })}
                  {this.state.data &&
                    this.state.data.SHAPE &&
                    this.state.data.SHAPE.length &&
                    this.state.data.SHAPE.map((e, index1) => {
                      return (
                        <>
                          {e.points.map((p, index, arr) => {
                            return (
                              <tr key={index}>
                                <td style={{ border: '1px solid #a3a3a3' }}>
                                  {index === arr.length - 1 ? 1 : index + 1}
                                </td>
                                <td style={{ border: '1px solid #a3a3a3' }}>
                                  {StaticClass.formatNumberFloat(p.y)}
                                </td>
                                <td style={{ border: '1px solid #a3a3a3' }}>
                                  {StaticClass.formatNumberFloat(p.x)}
                                </td>
                              </tr>
                            );
                          })}
                        </>
                      );
                    })}
                </tbody>
              </table>
            </div>
          ) : null}
          <div id='listlocation'> </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    listQuan: state.search.listQuan,
    listPhuong: state.search.listPhuong,
  };
};

const mapDispatchToProps = {
  getDataQuan: getDataQuan,
  getDataPhuong: getDataPhuong,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchResultKienTruc);
